import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loaded: false,
  config: null,
};

const OrgConfigSlice = createSlice({
  name: "OrgConfig",
  initialState,
  reducers: {
    recieveOrgConfig(state, action) {
      state.config = action.payload;
      state.loaded = true;
    },
  },
});

export const { recieveOrgConfig } = OrgConfigSlice.actions;

export default OrgConfigSlice.reducer;
